import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
// import Home from '../views/Home.vue'
import NewHome from '../views/NewHome.vue'

const routes = [{
  path: '/',
  name: 'Home',
  component: NewHome
},
{
  path: '/daftar',
  name: 'Daftar',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import('../views/NewRegister.vue')
},
{
  path: '/login',
  name: 'Login',
  component: () => import('../views/NewLogin.vue')
},
{
  path: '/forgot-password',
  name: 'ForgotPassword',
  component: () => import('../views/ForgotPass.vue')
},
{
  path: '/verifikasi/:number/:type',
  name: 'Verifikasi',
  component: () => import('../views/Verifikasi.vue')
},
{
  path: '/cek-keanggotaan',
  name: 'CekAnggota',
  component: () => import('../views/CekAnggota.vue')
},
{
  path: '/kartu-anggota',
  name: 'ShowKartu',
  component: () => import('../views/ShowKartu.vue')
},
{
  path: '/registrasi-ulang',
  name: 'ReRegris',
  component: () => import('../views/ReRegris.vue')
},
{
  path: '/ubah-password',
  name: 'ChangePassword',
  component: () => import('../views/ChangePass.vue')
},
{
  path: '/redirect',
  name: 'redirect',
  component: () => import('../views/Redirect.vue'),
  meta: {
    bypassAuth: true
  }
},
{
  path: '/form-pendaftaran',
  name: 'FormDaftar',
  component: () => import('../views/FormPendaftaran.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/form-registrasi',
  name: 'FormRegistrasi',
  component: () => import('../views/RegisterMember.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/event-voucher',
  name: 'EventVoucher',
  component: () => import('../views/EventLayout.vue'),
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      component: () => import('../views/EventPage.vue'),
      name: 'event-list',
      meta: { requiresAuth: true }
    },
    {
      path: ':id',
      name: 'event-detail',
      component: () => import('../views/EventDetail.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: ':eventId/register',
      name: 'event-voucher-register',
      component: () => import('@/views/EventRegistrationPage.vue')
    }
  ]
},
{
  path: '/dashboard',
  name: 'Dashboard',
  component: () => import('../views/Dashboard.vue'),
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      component: () => import('../views/Dashboard/Home.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: 'event',
      component: () => import('../views/Dashboard/Event.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: 'dokumen',
      component: () => import('../views/Dashboard/Dokumen.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          component: () => import('../views/Dashboard/Dokumen/index.vue'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: 'agenda',
      component: () => import('../views/Dashboard/Agenda.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: 'pemilu&pilkada',
      component: () => import('../views/Dashboard/Pemilu&Pilkada.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: 'laporan',
      component: () => import('../views/Dashboard/Laporan.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: 'profil',
      component: () => import('../views/Dashboard/Profil.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: 'pemetaan-lokasi',
      component: () => import('../views/Dashboard/Lokasi.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/polls/:id',
      name: 'polls',
      component: () => import('../views/Polls.vue'),
      meta: { requiresAuth: true }
    }, {
      path: 'connect',
      component: () => import('../views/Dashboard/Connect/Connect.vue'),
      children: [
        {
          path: 'motionbank',
          name: 'ConnectMotionBank',
          component: () => import('../views/Dashboard/Connect/MotionBank.vue')
        },
        {
          path: 'motionbank/add',
          name: 'AddAccountMotionBank',
          component: () => import('../views/Dashboard/Connect/AddAccountMotionBank.vue')
        }
      ]
    }
  ]
},
{
  path: '/:catchAll(.*)',
  component: () => import('../views/404.vue')
}
]

const router = createRouter({
  history: createWebHashHistory(), routes
})

router.beforeEach(async (to, from, next) => {
  const { $cookie, $store } = router.app.config.globalProperties
  const token = $cookie.getCookie('token')

  if (token) {
    $store.commit('setToken', token)
    await $store.dispatch('verToken')
  }

  if (to.matched.some(record => record.meta.bypassAuth)) {
    next()
  }

  // this.logger($store.state.isLogin, 'isLogin beforeEach' , to)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this.logger("kesini")
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!$store.state.isLogin) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else {
    // this.logger('kesitu')
    if ($store.state.isLogin) {
      next({
        path: '/dashboard'
      })
    } else {
      next()
    }
  }
})

export default router
